import { FilterParams } from "../catalog-utils";

export const generateFilterObject = (filterParams: FilterParams) => {
    const {
        brandValue,
        modelValue,
        yearFromValue,
        yearToValue,
        engineVolumeFromValue,
        engineVolumeToValue,
        bodyValue,
        transmissionValue,
        engineTypeValue,
        driveValue,
        wheelValue,
        priceFromValue,
        priceToValue,
        mileageFromValue,
        mileageToValue,
        horsePowerFromValue,
        horsePowerToValue,
        generationValue,
        ownerQntFrom,
        ownersQntTo,
        citiesValue,
        sourceId,
        timeFrom,
        sellerType,
        sort,
        created_at,
        cityAlias,
        brandAlias,
        modelAlias,
        generationCode,
        restyling,
        country,
        hideNoImages
    } = filterParams;

    let filters: { [key: string]: any } = {};

    if (brandValue) filters["brandUuid"] = brandValue;
    if (modelValue) filters["modelUuid"] = modelValue;
    if (generationValue) filters["generationUuid"] = generationValue;
    if (yearFromValue) filters["from_year"] = yearFromValue;
    if (yearToValue) filters["to_year"] = yearToValue;
    if (engineVolumeFromValue) filters["from_displacement"] = engineVolumeFromValue;
    if (engineVolumeToValue) filters["to_displacement"] = engineVolumeToValue;
    if (bodyValue) filters["body_type"] = bodyValue;
    if (transmissionValue) filters["transmission_type"] = transmissionValue;
    if (engineTypeValue) filters["engine_type"] = engineTypeValue;
    if (driveValue) filters["drive_type"] = driveValue;
    if (wheelValue) filters["wheel_type"] = wheelValue;
    if (priceFromValue) filters["from_price"] = priceFromValue;
    if (priceToValue) filters["to_price"] = priceToValue;
    if (mileageFromValue) filters["from_mileage"] = mileageFromValue;
    if (mileageToValue) filters["to_mileage"] = mileageToValue;
    if (horsePowerFromValue) filters["from_horse_power"] = horsePowerFromValue;
    if (horsePowerToValue) filters["to_horse_power"] = horsePowerToValue;
    if (ownerQntFrom) filters["from_owners_count"] = ownerQntFrom;
    if (ownersQntTo) filters["to_owners_count"] = ownersQntTo;
    if (citiesValue && citiesValue.length > 0) filters["city"] = citiesValue[0].name;
    if (sourceId && sourceId.length > 0) filters["source_id"] = sourceId;
    if (timeFrom) filters["timeFrom"] = timeFrom;
    if (sellerType) filters["seller_type"] = sellerType;
    if (sort) filters["sort"] = sort;
    if (typeof created_at === "string") filters["created_at"] = created_at;
    if (cityAlias) filters["cityAlias"] = cityAlias;
    if (brandAlias) filters["brandAlias"] = brandAlias;
    if (modelAlias) filters["modelAlias"] = modelAlias;
    if (generationCode) filters["generation"] = generationCode;
    if (restyling) filters["restyling"] = restyling;
    if (country) filters["country"] = country;
    if (hideNoImages) filters["hideNoImages"] = hideNoImages;

    return filters;
};